import { GET_CHEAPEST_HOTELS_QUERY, SEARCH_ITINERARIES_SUBSCRIPTION } from './queries';
import {
    CheapestHotelsRequestQL,
    CheapestHotelsResponseQL,
    SearchItinerariesRequestQL,
    SearchItinerariesResponseQL,
    SmartSearchEndpoint as SmartSearchEndpointModel,
} from './smartSearch.interfaces';
import client from './smartSearch.client';

export class SmartSearchEndpoint implements SmartSearchEndpointModel {
    public async GetCheapestHotels(
        request: CheapestHotelsRequestQL
    ): Promise<CheapestHotelsResponseQL[]> {
        return getCheapestHotelsFetch(request);
    }

    public async SearchItineraries(
        recipe: SearchItinerariesRequestQL
    ): Promise<SearchItinerariesResponseQL> {
        return getSearchItinerariesFetch(recipe);
    }
}
export class FakeSmartSearchEndpoint implements SmartSearchEndpointModel {
    // Replace with static fake data
    public async GetCheapestHotels(
        request: CheapestHotelsRequestQL
    ): Promise<CheapestHotelsResponseQL[]> {
        return getCheapestHotelsFetch(request);
    }

    public async SearchItineraries(
        recipe: SearchItinerariesRequestQL
    ): Promise<SearchItinerariesResponseQL> {
        return getSearchItinerariesFetch(recipe);
    }
}

async function getCheapestHotelsFetch(
    request: CheapestHotelsRequestQL
): Promise<CheapestHotelsResponseQL[]> {
    return new Promise((resolve, reject) => {
        try {
            const observable = client.subscribe({
                query: GET_CHEAPEST_HOTELS_QUERY,
                variables: { request },
            });

            const responses: CheapestHotelsResponseQL[] = [];

            observable.subscribe({
                next(res) {
                    const cheapestHotels = res?.data?.getCheapestStayByHotel;
                    if (cheapestHotels) {
                        responses.push(cheapestHotels);
                    }
                },
                error(error) {
                    reject(
                        error ??
                            new Error(
                                '[SmartSearch] Error occurred while fetching cheapest hotels in observable.'
                            )
                    );
                },
                complete() {
                    resolve(responses.length > 0 ? responses : []);
                },
            });
        } catch {
            const error = new Error(
                '[SmartSearch] Unknown error occurred while fetching cheapest hotels.'
            );
            reject(error);
        }
    });
}

async function getSearchItinerariesFetch(
    recipe: SearchItinerariesRequestQL
): Promise<SearchItinerariesResponseQL> {
    return new Promise((resolve, reject) => {
        try {
            const observable = client.subscribe({
                query: SEARCH_ITINERARIES_SUBSCRIPTION,
                variables: { recipe },
            });

            let response: SearchItinerariesResponseQL;

            observable.subscribe({
                next(res) {
                    const searchedItinerary = res?.data?.searchRecipeByItinerary;
                    if (searchedItinerary) {
                        response = searchedItinerary;
                    }
                },
                error(error) {
                    reject(
                        error ??
                            new Error(
                                '[SmartSearch] Error occurred while fetching search itinerary in observable.'
                            )
                    );
                },
                complete() {
                    resolve(
                        response?.result?.length > 0
                            ? response
                            : ({} as SearchItinerariesResponseQL)
                    );
                },
            });
        } catch {
            const error = new Error(
                '[SmartSearch] Unknown error occurred while fetching search itinerary.'
            );
            reject(error);
        }
    });
}
